import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    clarity: (...args: any[]) => void;
  }
}

const Analytics = () => {
  const location = useLocation();
  const ga4Id = import.meta.env.VITE_GA4_ID as string | undefined;
  const clarityId = import.meta.env.VITE_CLARITY_ID as string | undefined;
  const isProd = import.meta.env.PROD;

  // Inject GA4 script once
  useEffect(() => {
    if (!isProd || !ga4Id) return;
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", ga4Id, { send_page_view: false });
  }, [ga4Id, isProd]);

  // Inject Clarity script once
  useEffect(() => {
    if (!isProd || !clarityId) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${clarityId}");`;
    document.head.appendChild(script);
  }, [clarityId, isProd]);

  // Track route changes
  useEffect(() => {
    if (!isProd || !ga4Id || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
    });
  }, [location, ga4Id, isProd]);

  return null;
};

export default Analytics;
